import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SalesManEntity } from '../../domain/entities/SalesManEntity'

export class SalesManModel extends SalesManEntity {
  constructor(dataDto: SalesManModel) {
    super()
    mapEntityProperties<SalesManModel>(this, dataDto)
  }
}
